import { normalizeYear } from "./normalizeYear";

/**
 * @param {{response: { data: import("../../types/Year").Year[] }}} params
 *
 * @return {{data: import("../../types/Year").Year[]}}
 */
export const normalizeYearsResponse = ({ response }) => {
  return {
    data: response.data.map((year) => normalizeYear({ year })),
  };
};
